import React from 'react';
import PostMargins from '../postmargins';

const styles = {
    serviceWrapper: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        margin: "25px 0"
    },
    serviceImage: {
        width: 30,
        height: 30,
        objectFit: 'contain',
        marginRight: 27,
        borderRadius: 2,
        opacity: ".5"
    },
    serviceText: {
        fontWeight: 600,
        fontFamily: 'Hind, sans-serif',
        fontSize: 20,
        textTransform: 'uppercase',
        lineHeight: 1.25
    },
    primaryContentContainer: { // wrapper around first body inside primaryBodyContainer
        boxSizing: 'border-box'
    }
};

const ClientPost = ({post}) => {
    const bp = polyphony.hooks.useBreakpoint();
    const isMobile = bp === 'mobile';

    const [primaryBody, ...bodies] = post.content;
    const {services} = post.taxonomies;
    const {PostWrapper, SharingButtons, PostBody} = polyphony.components.frontend;
    const {RawHTML, Image} = polyphony.components.generic;

    return (
        <PostWrapper post={post} style={{display: 'flex', flexFlow: 'column nowrap', alignItems: 'center'}}>
            <PostMargins>
                <div style={!isMobile && services.length > 0 ? {flex: "2 0 66%", paddingRight: 130, boxSizing: 'border-box', width: '100%'} : {width: '100%'}}>
                    <PostBody>{primaryBody}</PostBody>
                    <SharingButtons twitter facebook linkedin email url={post.permalink}/>
                </div>
                {services.length > 0 && <div style={isMobile ? {} : {flex: "1 2 33%"}}>
                    {services.map(({name, logo}) => <div key={name} style={styles.serviceWrapper}>
                        <Image lazy media={logo} style={styles.serviceImage} />
                        <span style={styles.serviceText}>{name}</span>
                    </div>)}
                </div>}
            </PostMargins>
            {bodies.map((x, i) => <div key={i} style={{backgroundColor: 'black', width: '100%'}}><PostBody>{x}</PostBody></div>)}
        </PostWrapper>
    );
};

export default ClientPost;

